import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, Button, Form } from 'react-bootstrap';

// The owner's way back in when the password is lost or changed by someone else: one of the
// offline recovery codes sets a new password and ends every session of every user.
const RecoveryPage = () => {
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Las contraseñas no coinciden.'); return; }
    setBusy(true);
    try {
      const { data } = await axios.post('/api/recovery/reset', { username: username.trim(), code: code.trim(), newPassword: password });
      setDone(data);
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo completar la recuperación.');
    } finally { setBusy(false); }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center" style={{ background: 'var(--mm-bg)' }}>
      <Card className="shadow-lg p-4" style={{ maxWidth: 460, width: '100%', borderRadius: 16 }}>
        <div className="text-center mb-3">
          <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1.8rem', color: 'var(--mm-brand)', fontWeight: 700 }}>VENTAS</div>
          <h4 className="mt-1 mb-0" style={{ color: 'var(--mm-muted)', fontSize: '1.05rem', fontWeight: 500 }}>Recuperar el acceso de propietario</h4>
        </div>

        {done ? (
          <>
            <div className="alert alert-success">
              <strong>{done.message}</strong>
              <div className="small mt-1">Por seguridad se cerraron las sesiones de todos los usuarios. Te quedan {done.remaining} código(s) de recuperación.</div>
            </div>
            <Link to="/login" className="btn btn-primary w-100">Ir a iniciar sesión</Link>
          </>
        ) : (
          <Form onSubmit={submit}>
            <p className="small text-muted">
              Escribe tu usuario de propietario y uno de los códigos de recuperación que guardaste fuera de línea. Cada código sirve una sola vez.
              Al terminar se cierran las sesiones de <strong>todos</strong> los usuarios.
            </p>
            {error && <div className="alert alert-danger py-2">{error}</div>}
            <Form.Group className="mb-2">
              <Form.Label className="d-block small text-muted mb-1">Usuario</Form.Label>
              <Form.Control autoFocus autoComplete="off" value={username} onChange={e => setUsername(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="d-block small text-muted mb-1">Código de recuperación</Form.Label>
              <Form.Control autoComplete="off" placeholder="XXXX-XXXX-XXXX" style={{ fontFamily: 'monospace', letterSpacing: '0.08em' }} value={code} onChange={e => setCode(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="d-block small text-muted mb-1">Nueva contraseña <span className="text-muted">(mínimo 8 caracteres)</span></Form.Label>
              <Form.Control type="password" autoComplete="new-password" value={password} onChange={e => setPassword(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="d-block small text-muted mb-1">Repite la nueva contraseña</Form.Label>
              <Form.Control type="password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} />
            </Form.Group>
            <Button type="submit" className="w-100" disabled={busy || !username.trim() || !code.trim() || password.length < 8}>{busy ? 'Verificando...' : 'Restablecer contraseña'}</Button>
            <div className="text-center mt-3"><Link to="/login" className="small text-muted">Volver a iniciar sesión</Link></div>
          </Form>
        )}
      </Card>
    </div>
  );
};

export default RecoveryPage;
